module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/green/practice_tests_icon-b3640aeadb61b3c41d56d60f44214499.svg";